import { render, staticRenderFns } from "./AccountManageView.vue?vue&type=template&id=082b43d2&scoped=true"
import script from "./AccountManageView.vue?vue&type=script&lang=js"
export * from "./AccountManageView.vue?vue&type=script&lang=js"
import style0 from "./AccountManageView.vue?vue&type=style&index=0&id=082b43d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b43d2",
  null
  
)

export default component.exports